import { render, staticRenderFns } from "./product-form-page.vue?vue&type=template&id=69b9c050&"
import script from "./product-form-page.vue?vue&type=script&lang=js&"
export * from "./product-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports